import React from "react";
import { Toolbar, Tooltip, IconButton, Typography } from "@material-ui/core";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";
//import DescriptionIcon from "@material-ui/icons/Description";
import AlternateEmailIcon from "@material-ui/icons/AlternateEmail";

import { useTheme, useMediaQuery } from "@material-ui/core";
import { Container } from "@material-ui/core";

const Footer = () => {
  //access to theme
  const theme = useTheme();
  //matchSmall is true if window is sm or less(down)
  const matchExtraSmall = useMediaQuery(theme.breakpoints.down("xs"));
  //sizing for buttonIcon size
  let size = "medium";
  matchExtraSmall ? (size = "medium") : (size = "medium"); //keeping size the same for now.

  return (
    <>
      <Toolbar />

      <Toolbar>
        <Container maxWidth='lg' align='center'>
          <Tooltip title='Github Repo'>
            <IconButton
              size={size}
              color='secondary'
              href='https://github.com/phutngo'
              target='_blank'
              rel='noreferrer'
            >
              <GitHubIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title='LinkedIn Profile'>
            <IconButton
              size={size}
              color='secondary'
              href='https://www.linkedin.com/in/phungo/'
              target='_blank'
              rel='noreferrer'
            >
              <LinkedInIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title='phu@phungo.dev'>
            <IconButton
              size={size}
              color='secondary'
              href='mailto:phu@phungo.dev?body=Hi%20Phu'
              target='_blank'
              rel='noreferrer'
            >
              <AlternateEmailIcon />
            </IconButton>
          </Tooltip>
        </Container>
      </Toolbar>
      <Toolbar>
        <Container maxWidth='lg' align='center'>
          <Typography variant='caption'>© Copyright 2021 Phu Ngo. All rights reserved.</Typography>
        </Container>
      </Toolbar>
    </>
  );
};

export default Footer;
